import React from 'react';
import { Card, Typography, Image } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import styles from './news.module.css';

const { Title, Paragraph } = Typography;

const NewsCard = ({ news, onClick, compact = false }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <Card
      hoverable
      onClick={() => onClick && onClick(news)}
      className={`${styles.newsCard} ${compact ? styles.compact : ''}`}
      cover={
        news.headerImage ? (
          <div className={styles.imageContainer}>
            <Image
              alt={news.title}
              src={news.headerImage}
              className={styles.cardImage}
              preview={false}
              fallback="/images/placeholder-news.svg"
            />
          </div>
        ) : null
      }
    >
      <div className={styles.cardContent}>
        <div className={styles.dateContainer}>
          <CalendarOutlined className={styles.dateIcon} />
          <span className={styles.dateText}>{formatDate(news.date)}</span>
        </div>
        
        <Title 
          level={compact ? 5 : 4} 
          className={styles.cardTitle}
          ellipsis={{ rows: 2 }}
        >
          {news.title}
        </Title>
        
        <Paragraph 
          className={styles.cardExcerpt}
          ellipsis={{ rows: compact ? 2 : 3 }}
        >
          {news.excerpt}
        </Paragraph>
      </div>
    </Card>
  );
};

export default NewsCard; 